import Photo, { type PhotoProps } from "@/components/Photo";
import { cardPhoto } from "@/lib/listing-image";

/**
 * A listing card's photo: the API's resized WebP copies with a srcset
 * for the card's `sizes` (lib/listing-image cardPhoto), the site's own
 * card file as the fallback; a site the API does not fetch keeps its
 * own URLs. Renders nothing without a photo, so callers keep their
 * placeholder branch. No hooks: server-rendered cards use it too.
 */
export default function CardPhoto({
  url,
  sizes,
  ...rest
}: { url: string | null | undefined; sizes: string } & Omit<PhotoProps, "src" | "srcSet" | "sizes" | "fallbackSrc" | "sources">) {
  const photo = cardPhoto(url, sizes);
  if (!photo) return null;
  return (
    <Photo
      src={photo.src}
      srcSet={photo.srcSet}
      sizes={photo.sizes}
      fallbackSrc={photo.fallbackSrc}
      sources={photo.phoneSrc ? <source media="(max-width: 640px)" srcSet={photo.phoneSrc} /> : undefined}
      {...rest}
    />
  );
}
